var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{class:['checkbox'],attrs:{"label":_vm.label,"name":_vm.name,"value":_vm.value,"input-value":_vm.inputValue},on:{"change":_vm.onChange}},[_vm._t("label",null,{"slot":"label"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }